import WalletsInfo from "./WalletsInfo";
export {WalletsInfo}